// pdp download form popup
const downloadPopTarget = document.querySelector('#downloadForm-popup');
const downloadPopTriggers = document.querySelectorAll('.downloadForm');
const downloadPopOverlay = document.querySelector('#downloadForm-popup .cc-popup-background');
const downloadFormPopClose = document.querySelector('#downloadForm-popup .download-popup-wrapper .cc-popup-close');

// If the popup doesn't exist on this page, do nothing (prevents console errors)
if (!downloadPopTarget) {
  // Optional: you can also check triggers length, but target is the key element
} else {
  function openPopup(e) {
    // Prevent jump if triggers are links
    if (e) e.preventDefault();
    downloadPopTarget.classList.add('cc-popup--visible');
  }

  function closePopup() {
    downloadPopTarget.classList.remove('cc-popup--visible');
  }

  // Triggers may or may not exist depending on the page
  if (downloadPopTriggers && downloadPopTriggers.length) {
    downloadPopTriggers.forEach((trigger) => {
      trigger.addEventListener('click', openPopup);
    });
  }

  // Overlay/close may not exist depending on markup
  if (downloadPopOverlay) {
    downloadPopOverlay.addEventListener('click', closePopup);
  }

  if (downloadFormPopClose) {
    downloadFormPopClose.addEventListener('click', closePopup);
  }
}